module.exports = "<div class=\"block-editable block-std\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce in felis a risus pellentesque pulvinar. Etiam vehicula molestie libero et sodales. Donec consequat ultrices est at vestibulum. Cras pretium felis vitae mi sodales, convallis finibus leo tincidunt. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus tincidunt egestas nunc, vitae pellentesque quam porttitor ut. Maecenas posuere pellentesque risus ut pulvinar.\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/block-editable/sample.html
// module id = 56
// module chunks = 0